import { SITE } from "../lib/site";
import { Phone } from "lucide-react";

export default function AnnouncementBar() {
  return (
    <div
      data-testid="announcement-bar"
      className="relative z-40 bg-[#050505] border-b border-gold/25"
    >
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10 py-2.5 sm:py-3 flex flex-col sm:flex-row items-center justify-center sm:justify-between gap-2 sm:gap-4 text-center sm:text-left">
        <div className="flex items-center gap-3 min-w-0">
          <span className="relative flex h-2.5 w-2.5 shrink-0">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-gold opacity-75" />
            <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-gold" />
          </span>
          <p className="text-xs sm:text-[13px] text-white/80 leading-snug">
            <span className="text-gold font-medium uppercase tracking-[0.14em]">
              Spots fill up fast
            </span>
            <span className="mx-2 text-white/25 hidden sm:inline">·</span>
            <span className="block sm:inline text-white/60">
              Don&apos;t see availability? Check back soon or text us — we&apos;re still detailing!
            </span>
          </p>
        </div>
        <a
          href={`sms:+1${SITE.phoneRaw}`}
          data-testid="announcement-text-us"
          className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.18em] text-gold hover:text-[#F3E5AB] whitespace-nowrap"
        >
          <Phone size={12} />
          Text {SITE.phone}
        </a>
      </div>
    </div>
  );
}
